<template>
  <modal-manager :modal-list="modalList"/>
</template>

<script>
import ModalManager from '@/modules/modal-manager/ModalManager';
import ModalConfig from './ModalConfig';

export default {
  name: 'ModalWrapper',
  data() {
    return {
      modalList: ModalConfig,
    };
  },
  components: {
    ModalManager,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/modal/ModalWrapper.vue